import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faCheck, faPen, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Modal } from 'react-bootstrap';
import CustomerInfo from './CustomerInfo';

const Table = ({
  customers,
  updateFutureCall,
  updateLeadParsent,
  renderProgressBar,
  markNI,
  setCustomers
}) => {
  const [selectedRemarks, setSelectedRemarks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [localDates, setLocalDates] = useState({});

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const d = new Date(dateString);
    const offset = d.getTimezoneOffset();
    const localDate = new Date(d.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split('T')[0];
  };

useEffect(() => {
  setLocalDates(prev => {
    const updated = { ...prev };
    customers.forEach(c => {
      const rawDate = c.new_future_call_date || c.future_call_date || '';
      updated[c.id] = formatDate(rawDate);
    });
    return updated;
  });
}, [customers]);

  const openRemarksModal = (remarks) => {
    setSelectedRemarks(remarks);
    setShowModal(true);
  };

  const handleDateChange = (id, selectedDate) => {
    const dateObj = new Date(`${selectedDate}T12:00:00`);
    if (dateObj.getDay() === 0) return alert("❌ Sunday not allowed.");

    setLocalDates(prev => ({ ...prev, [id]: selectedDate }));
    const updated = customers.map(c =>
      c.id === id ? { ...c, new_future_call_date: selectedDate } : c
    );
    setCustomers(updated);
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border text-sm text-left">
        <thead className="bg-gray-800 text-white">
          <tr>
            <th className="px-3 py-2 border">SN</th>
            <th className="px-3 py-2 border">Customer Info</th>
            <th className="px-3 py-2 border">Sales Person</th>
            <th className="px-3 py-2 border">Source</th>
            <th className="px-3 py-2 border">Work Details</th>
            <th className="px-3 py-2 border">Call</th>
            <th className="px-3 py-2 border">Future Call</th>
            <th className="px-3 py-2 border">Remarks</th>
            <th className="px-3 py-2 border">Interest Level</th>
            <th className="px-3 py-2 border">Status / Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((c, i) => (
            <tr key={c.id} className="hover:bg-gray-50">
              <td className="px-3 py-2 border">{i + 1}</td>
              <td className="px-3 py-2 border"><CustomerInfo customer={c} /></td>
              <td className="px-3 py-2 border font-semibold">{c.salesman_name}</td>
              <td className="px-3 py-2 border">
                <strong>{c.source}</strong><br />
                <span className="text-gray-500 text-xs">{new Date(c.created_at).toLocaleDateString()}</span>
              </td>
              <td className="px-3 py-2 border">{c.work_details}</td>
              <td className="px-3 py-2 border">
                {c.contact_number ? (
                  <div className="flex flex-col gap-1">
                    <a href={`tel:${c.contact_number}`} className="btn-sm bg-green-500 text-white rounded px-2 py-1">
                      <FontAwesomeIcon icon={faPhone} />
                    </a>
                    <a href={`https://wa.me/${c.contact_number}`} target="_blank" rel="noreferrer" className="btn-sm bg-green-600 text-white rounded px-2 py-1">
                      <FontAwesomeIcon icon={faWhatsapp} />
                    </a>
                  </div>
                ) : (
                  <span className="text-gray-400 italic">No Contact</span>
                )}
              </td>
              <td className="px-3 py-2 border">
                <div className="flex gap-2 items-center">
                  <input
                    type="date"
                    value={localDates[c.id] || ''}
                    onChange={(e) => handleDateChange(c.id, e.target.value)}
                    className="border rounded px-2 py-1 text-sm"
                  />
                  <button
                    className="bg-blue-600 text-white rounded px-2 py-1 text-sm"
                    onClick={() => updateFutureCall(c.id, localDates[c.id])}
                  >
                    Update
                  </button>
                </div>
              </td>
              <td className="px-3 py-2 border">
                {Array.isArray(c.remark) && c.remark.length > 0 ? (
                  <>
                    <ul className="text-sm list-disc pl-4">
                      {c.remark.slice(-2).reverse().map((r, idx) => (
                        <li key={idx}><strong>{r.date || ''}:</strong> {r.text || r}</li>
                      ))}
                    </ul>
                    {c.remark.length > 2 && (
                      <button
                        className="text-blue-600 text-sm mt-1 underline"
                        onClick={() => openRemarksModal(c.remark)}
                      >
                        View All
                      </button>
                    )}
                  </>
                ) : (
                  <em className="text-gray-400 text-sm">No remarks</em>
                )}
                <Link to={`/dashboard/remarks/add/${c.id}`} className="block text-blue-500 mt-1 text-sm underline">
                  + Add Remark
                </Link>
              </td>
              <td className="px-3 py-2 border">
                {renderProgressBar(c.lead_parsent)}
                <div className="flex items-center gap-2 mt-1">
                  <input
                    type="number"
                    className="border rounded px-2 py-1 w-16 text-sm"
                    defaultValue={c.lead_parsent}
                    onBlur={(e) => updateLeadParsent(c.id, e.target.value)}
                    min={0}
                    max={100}
                  />
                  <button
                    type="button"
                    className="bg-green-600 text-white rounded px-2 py-1 text-sm"
                    onClick={() => updateLeadParsent(c.id, c.lead_parsent)}
                  >
                    <FontAwesomeIcon icon={faCheck} />
                  </button>
                </div>
              </td>
              <td className="px-3 py-2 border">
                <div className="flex flex-wrap gap-2">
                  {c.status === 0 && (
                    <>
                      <Link to={`/dashboard/customers/${c.id}/done`} className="bg-green-700 text-white rounded px-3 py-1 text-sm">
                        Done <FontAwesomeIcon icon={faCheck} />
                      </Link>
                      <Link to={`/dashboard/customers/${c.id}/edit`} className="bg-blue-700 text-white rounded px-3 py-1 text-sm">
                        <FontAwesomeIcon icon={faPen} />
                      </Link>
                    </>
                  )}
                  <button
                    className="bg-red-600 text-white rounded px-3 py-1 text-sm"
                    onClick={() => markNI(c.id)}
                  >
                    <FontAwesomeIcon icon={faTimesCircle} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Remarks Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>All Remarks</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRemarks.length > 0 ? (
            <ul className="list-disc pl-5">
              {selectedRemarks.map((r, idx) => (
                <li key={idx} className="text-sm">
                  <strong>{r.date || ''}:</strong> {r.text || r}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500 italic">No remarks found.</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Table;